<template>
  <label
    class="CoverageRadio"
    :for="`${id}-${value}`"
  >
    <div
      class="card"
      :class="{ selected }"
    >
      <input
        type="radio"
        :value="value"
        :id="`${id}-${value}`"
        :checked="selected"
      />
      <span
        class="text"
        v-html="text"
      ></span>
      <div class="tooltip">
        <BaseTooltip
          v-if="tooltip"
          :text="tooltip"
        />
      </div>
      <span class="help-text">{{ helpText }}</span>
    </div>
  </label>
</template>
<script setup lang="ts">
  import BaseTooltip from '@/modules/core/components/ui/BaseTooltip.vue'

  interface PropsInterface {
    id: string
    text: string
    tooltip?: string
    helpText?: string
    value: string | number | null
    modelValue: string | number | null
    selected: boolean
  }
  withDefaults(defineProps<PropsInterface>(), {
    tooltip: undefined,
    selected: false
  })
</script>
<style scoped lang="scss">
  .card {
    cursor: pointer;
    display: grid;
    grid-template-columns: 0.1fr 1fr 0.1fr;
    grid-template-rows: repeat(2, 0.1fr);
    align-items: center;
    grid-gap: $gap-0;

    .text {
      font-weight: bold;
    }

    .help-text {
      color: $color-neutral;
      grid-column: span 3;
      grid-column-start: 2;
    }

    .tooltip {
      margin: 0 auto;
    }
  }
</style>
